module.exports = __webpack_public_path__ + "img/problem3.47394a4c.png";